<template>
  <div
    id="canvasContainer"
    :style="{
      width: screenWidth,
    }"
    class="flex flex-col shadow-md rounded-b-lg h-full mr-auto ml-auto mb-10"
  >
    
    <!-- form preview -->
    <div class="flex items-center px-3 py-2 bg-grey-100 rounded-t-lg relative">
      <div class="flex">
        <div class="rounded-full bg-red w-3 h-3 mr-2"></div>
        <div class="rounded-full bg-yellow w-3 h-3 mr-2"></div>
        <div class="rounded-full bg-green w-3 h-3"></div>
      </div>
      <div class="font-bold ml-4 text-grey-700 text-md">{{ localModel.name }}</div>
      <div class="flex absolute" style="right: 10px; top: 10px;">
        <div
          class="cursor-pointer text-grey-700 mx-2 flex align-center gap-2"
          v-if="substep == 'design' && localModel.form_fields.layout_type == 'custom'"
          @click="toggleColumns"
        >
        
          <PreviewCrossedIcon 
            class="h-4 w-4 self-center"
            v-if="showRows" key="eyeslash"
          />
          
          <PreviewIcon 
            class="h-4 w-4 self-center"
            v-else key="eye"
          />

          <span>
            {{ $t('frontend_rows') }} / {{$t('frontend_columns') }}
          </span>
        </div>
      </div>
    </div>
    
    <div
      id="groovemail-form-preset"
      class="groovemail-form-preset h-full overflow-y-auto overflow-x-hidden custom-scrollbars relative rounded form-content-box mx-auto w-full"
      v-if='localModel && activePreset'
    >
      <div v-show="!printing">
        <div
          class='relative rounded groovemail-form-content'
          :style="
            '--gp-bg-front-color:' + activePreset.styles.form.backgroundPatternFrontColor + ';' +
            '--gp-bg-front-alpha-color:' + (activePreset.styles.form.backgroundPatternFrontColor??'').replace('1)', '0.333)') + ';' +
            '--gp-bg-back-color:' + activePreset.styles.form.backgroundPatternBackColor + ';' +
            '--gp-bg-spacing:' + activePreset.styles.form.backgroundPatternSpacing + 'px;' +
            '--gp-bg-opacity:' + ((activePreset.styles.form.backgroundPatternOpacity??100)/100)+ ';' +
            'background-color:' + activePreset.styles.form.backgroundColor + ';' +
            'background-blur:' + (activePreset.styles.form.backgroundBlur??0) + 'px;' +
            'color:' + activePreset.styles.form.color + ';' +
            'padding: ' + activePreset.styles.form.padding.join('px ') + 'px;' +
            'margin: ' + activePreset.styles.form.margin.join('px ') + 'px;' +
            'border-width:' + activePreset.styles.form.border?.width.join('px ') + 'px;' +
            'border-radius:' + activePreset.styles.form.border?.radius.join('px ') + 'px;' +
            'border-color:' + activePreset.styles.form.border?.color.join(' ') + ';' +
            'border-style:' + activePreset.styles.form.border?.style.join(' ') + ';' +
            'background-size:' + activePreset.styles.form.backgroundSize + ';' +
            'background-position:' + activePreset.styles.form.backgroundPosition + ';' +
            'background-repeat:' + activePreset.styles.form.backgroundRepeat + ';' +
            'background-image:' + 
            (activePreset.styles.form.backgroundImage == null ? 'none' : activePreset.styles.form.backgroundImage ) + ';' +
            activePreset.styles.form.customStyles ?? ''
          "
          @click="showFieldsActionItems('form')"
          @mouseleave="hideFieldsActionItems()"
        >

          <div class="flex flex-wrap relative" id='groovemail-form-fields-area'>

            <draggable group="rows" :list="rows" class="dragArea w-full">
              <div
                @mouseover="mouseoo('row')"
                :class="{'form-row min-h-10': showRows}"
                class="w-full flex"
                v-for="(row, indexRow) in rows"
                :key="indexRow"
              >
                <div
                  v-if="rows.length > 1"
                  @click="deleteRow(indexRow)"
                  class="delete_row"
                >
                  <DeleteIcon class="h-5 w-5"/>
                </div>
                <draggable group='columns' class="w-full flex space-x-4" :list="row">
                  <div
                    @mouseover.stop="mouseoo('column')"
                    v-for="(column, indexCol) in row"
                    :key="indexCol"
                    :class="{
                      'w-full': column.width==100,
                      'w-1/2': column.width==50,
                      'w-1/3': column.width==33,
                      'formColumn': showRows
                    }"
                    class="formColumn2"
                  >
                    <!-- Delete column -->
                    <div
                      v-if="row.length > 1"
                      @click="deleteCol(indexRow, indexCol)"
                      class="delete_col"
                    >
                      <DeleteIcon class="h-5 w-5"/>
                    </div>

                    <!-- Form content -->
                    <draggable
                      :list="column.fields"
                      group="fields"
                      class="w-full min-h-full"
                      :class="{
                        'formPlaceholder': showRows,
                        'flex-row flex': (
                          localModel.form_fields.layout_type == 'horizontal' &&
                          substep == 'design' &&
                          parseInt(screenWidth) > 640
                        ),
                        'flex-col flex': localModel.form_fields.layout_type != 'horizontal',
                      }"
                    >
                      <div
                        class="form-builder-wrapper"
                        :class="{'w-full': (
                          localModel.form_fields.layout_type == 'horizontal' &&
                          substep == 'design' &&
                          parseInt(screenWidth) > 640
                        )}"
                        @mouseover.stop="mouseoo('el')"
                        v-for="(element, mainindex) in column.fields"
                        :key="mainindex"
                      >
                        <div class="flex flex-col relative">
                          <!-- drag field button -->
                          <div class="w-2 mr-2 absolute" v-if="showRows == 123" style="top: 8px; left: -32px">
                            <DragIcon class="h-6 w-6 text-grey-500" />
                          </div>

                          <!-- Edit and delete field -->
                          <div
                            v-if="showActionItems && mainindex === currentFieldHovered"
                            class="absolute left-0"
                            :class="{'form-hover-field-tooltip': mainindex > 1, 'form-hover-field-tooltip-start': mainindex <=1}"
                          >
                            <div
                              class="bg-secondary-darker h-10 flex items-center btn-radius px-4 py-2"
                            >
                              <span class="text-sm text-secondary-invert font-semibold"
                                v-if="!['paragraph', 'heading', 'subheading'].includes(element.fieldtype)"
                              >
                                {{ $t('frontend_edit') }}
                                {{ $t('frontend_groovemail_campains_show_field') }}
                              </span>
                              <span
                                class="mr-3 ml-5 cursor-pointer"
                                @click="editChoosenField(element, mainindex)"
                                v-if="!['paragraph', 'heading', 'subheading'].includes(element.fieldtype)"
                              >
                                <EditIcon class="h-5 w-5 text-secondary-invert" />
                              </span>
                              <span
                                v-if="element.identifier !== 'Email'"
                                class="cursor-pointer text-secondary-invert"
                                @click="removeFieldFromForm(element, mainindex)"
                              >
                                <DeleteIcon class="h-5 w-5 text-secondary-invert"/>
                              </span>
                              <span
                                v-if="element.identifier === 'Email'"
                                class="cursor-not-allowed"
                              >
                                <DeleteIcon class="h-5 w-5 text-secondary-invert pointer-events-none opacity-50"/>
                              </span>
                            </div>
                          </div>
                          
                          <!-- Add sublabe button -->
                          <div
                            v-if="showActionItems && currentFieldHovered === 'button' && element.type == 'submit'"
                            class="absolute left-0"
                            style="padding-bottom: 5px; top: -45px"
                          >
                            <div
                              class="bg-secondary-darker h-10 flex items-center btn-radius px-4 py-2"
                            >
                              <span v-if="!localModel.form_fields.button_sublabel" class="text-sm text-secondary-invert font-semibold">
                                {{ $t('frontend_add_sublabel') }}
                              </span>
                              <span v-else class="text-sm text-secondary-invert font-semibold">
                                {{ $t('frontend_remove_sublabel') }}
                              </span>
                              <span
                                class="ml-6 cursor-pointer"
                                @click="toggleButtonSublabel"
                              >
                                <PlusIcon class="h-7 w-7 text-secondary-invert" v-if="!localModel.form_fields.button_sublabel" />
                                <DeleteIcon class="h-5 w-5 text-secondary-invert" v-else/>
                              </span>
                            </div>
                          </div>

                          <form-paragraph
                            v-model="column.fields[mainindex]"
                            :editable="substep == 'build'"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, column.fields[mainindex].type)"
                          ></form-paragraph>

                          <form-text-box
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @clicked="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></form-text-box>

                          <form-dropdown
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="activePreset.styles.field"
                          ></form-dropdown>

                          <form-text-area
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></form-text-area>

                          <form-radio
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></form-radio>

                          <form-accept
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></form-accept>

                          <form-checkbox
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></form-checkbox>

                          <form-button
                            :editable="substep == 'build'"
                            :class="buttonClass"
                            v-if="column.fields[mainindex].type === 'submit'"
                            v-model="localModel.form_submit_button_text"
                            :sublabel.sync="localModel.form_fields.button_sublabel"
                            :styles="{button: activePreset.styles.button, sublabel: activePreset.styles.button_sublabel}"
                            @click.native.stop="showFieldsActionItems('button')"
                            @mouseleave="hideFieldsActionItems()"
                          ></form-button>

                          <Form-date-box
                            v-model="column.fields[mainindex]"
                            :index="mainindex"
                            @click.native.stop="showFieldsActionItems(mainindex)"
                            @clicked="showFieldsActionItems(mainindex)"
                            @mouseleave="hideFieldsActionItems()"
                            :styles="getStyle(column.fields[mainindex].id, 'field')"
                          ></Form-date-box>

                          <!-- Edit custom field -->
                          <portal
                            to="modalWrapper"
                            v-if="
                              showEditStandardFieldPopup &&
                              localModel.form_fields.fields[mainindex].id === standardEditModel.id
                            "
                          >
                            <div class="w-full absolute inset-0 bg-black bg-opacity-40 flex items-center pb-12 z-50">
                          <div
                            class="edit-standard-field-popup p-6 max-w-md mx-auto"
                            v-if="
                              showEditStandardFieldPopup &&
                              localModel.form_fields.fields[mainindex].id === standardEditModel.id
                            "
                          >
                            <div
                              class="w-full cursor-not-allowed mb-6"
                              :title="
                                $t(
                                  'frontend_groovemail_forms_step1_field_type_cant_be_edited'
                                )
                              "
                            >
                              <p class="font-semibold text-sm mb-2">
                                {{ $t('frontend_groovemail_customfields_index_type') }}
                              </p>
                              <treeselect
                                class="pointer-events-none text-sm text-dark rounded-lg w-full disabled-treeselect custom-treeselect"
                                v-model="standardFieldType"
                                :multiple="false"
                                :options="customFieldOptions"
                                :closeOnSelect="closeOnSelect"
                                :clearable="clearable"
                                :clearOnSelect="clearOnSelect"
                                :placeholder="
                                  $t('frontend_groovemail_contacts_step2_select_field')
                                "
                              />
                            </div>

                            <div
                              class="w-full relative mb-6 cursor-not-allowed"
                              :title="
                                $t(
                                  'frontend_groovemail_forms_step1_field_identifier_cant_be_edited'
                                )
                              "
                            >
                              <p class="font-semibold text-sm mb-2">
                                {{
                                  $t(
                                    'frontend_groovemail_customfields_index_field_identifier'
                                  )
                                }}
                              </p>
                              <text-input
                                variant="base"
                                :disabled="true"
                                v-model="standardEditModel.name"
                                :placeholder="$t('frontend_groovemail_forms_enter_field_identifier')"
                              />
                            </div>
                            <div class="w-full">
                              <div>
                                <div class="mb-2">
                                  <p class="text-sm font-semibold mb-2">
                                    {{
                                      $t(
                                        'frontend_groovemail_customfields_index_field_default'
                                      )
                                    }}
                                  </p>
                                  <text-input
                                    variant="base"
                                    v-model="standardEditModel.placeholder"
                                    :validator="$v.standardEditModel.placeholder"
                                    :placeholder="$t('frontend_groovemail_forms_enter_placeholder_text')"
                                  />
                                </div>
                                <div
                                  class="flex mb-6"
                                  v-if="
                                    standardEditModel.name !== 'email'
                                  "
                                >
                                  <gd-checkbox
                                    class="mr-2"
                                    :value="standardEditModel.mandatory"
                                    :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                                    labelClass="font-semibold text-sm text-grey-700"
                                    size="sm"
                                    variant="primary"
                                    @change="isStandardFieldMandatory(standardEditModel)"
                                  />
                                </div>
                                <div
                                  class="flex mb-6 cursor-not-allowed"
                                  v-if="
                                    standardEditModel.name === 'email'
                                  "
                                >
                                  <gd-checkbox
                                    class="mr-2 pointer-events-none opacity-50"
                                    :value="standardEditModel.mandatory"
                                    :label="$t('frontend_groovemail_forms_step1_field_is_required')"
                                    labelClass="font-semibold text-sm text-grey-700"
                                    size="sm"
                                    variant="primary"
                                  />
                                </div>
                              </div>
                            </div>
                            <div class="flex justify-end">
                              <gd-button
                                class="mr-2"
                                style="min-width: 88px"
                                @click="closeStandardFieldEditPopup()"
                              >
                                {{ $t('frontend_cancel') }}
                              </gd-button>
                              <gd-button
                                variant="primary"
                                style="min-width: 88px"
                                @click="updateStandardField(mainindex)"
                              >
                                {{ $t('frontend_update') }}
                              </gd-button>
                            </div>
                          </div>
                          </div>
                          </portal>

                          <!-- Create custom field -->
                          <portal
                            to="modalWrapper"
                            v-if="
                              showEditCustomFieldPopup &&
                              localModel.form_fields.fields[mainindex].id ==
                                customFieldEditId
                            "
                          >
                            <div class="w-full absolute inset-0 bg-black bg-opacity-40 flex items-center z-50">
                          <div
                            class="edit-custom-field-popup max-w-md mx-auto"
                            v-if="
                              showEditCustomFieldPopup &&
                              localModel.form_fields.fields[mainindex].id ==
                                customFieldEditId
                            "
                          >
                            <create-update-field
                              type="edit"
                              from="forms"
                              :customfieldData="customfieldData"
                              @showLoader="showLoader"
                              @hideLoader="hideLoader"
                              @fetchfields="fetchandAssignCustomFields"
                              @closeEditFieldModal="closeCustomFieldEditPopup"
                            ></create-update-field>
                          </div>
                          </div>
                          </portal>
                        </div>
                      </div>
                    </draggable>
                  </div>
                </draggable>
              </div>
            </draggable>

            <!-- Add new field modal -->
            <portal to="modalWrapper" v-if="showInputOnAddField">
              <div
                class="w-full absolute inset-0 bg-black bg-opacity-40 flex items-end pb-12 z-50" 
                id="add-new-field-wrapper"
                v-if="showInputOnAddField"
              >
                <div class="p-6 w-full max-w-md mx-auto add-new-field-popup">
                  <div class="flex relative mb-4">
                    <div class="w-full">
                      <treeselect
                        v-model="currentSelectedField"
                        class="h-10 custom-treeselect treeselect-add-new custom-multilevel-select"
                        :multiple="false"
                        :options="formFieldsData"
                        :closeOnSelect="closeOnSelect"
                        :clearable="clearable"
                        :clearOnSelect="clearOnSelect"
                        :isDefaultExpanded="true"
                        :defaultExpandLevel="1"
                        :showCount="true"
                        :disableBranchNodes="true"
                        @input="formFieldSelectedSelected"
                        :placeholder="
                          this.$t('frontend_groovemail_contacts_step2_select_field')
                        "
                      />
                    </div>
                    <div
                      v-if="showCustomPopupOnAddField"
                      class="absolute pt-2 add-new-custom-field-popup"
                    >
                      <create-update-field
                        type="add"
                        from="forms"
                        :customfieldData="null"
                        @showLoader="showLoader"
                        @hideLoader="hideLoader"
                        @fetchfields="fetchandAssignCustomFields"
                        @closeCreateFieldModal="closeAddCustomFieldPopup"
                      >
                      </create-update-field>
                    </div>
                  </div>
                  <div class="flex justify-end mt-6">
                    <gd-button
                      class="mr-2"
                      style="min-width: 88px"
                      @click="closeAddFieldPopup()"
                    >
                      {{ $t('frontend_cancel') }}
                    </gd-button>
                    <gd-button
                      variant="primary"
                      style="min-width: 88px"
                      @click="addFieldToForm()"
                    >
                      {{ $t('frontend_save') }}
                    </gd-button>
                  </div>
                </div>
              </div>
            </portal>

            <!-- Add new field button  -->
            <gd-button
              v-if="substep == 'build'"
              
              variant="primary"
              @click='openAddFieldToFormModal'
              class="mt-4 mx-3"
            >
              <PlusIcon class="h-6 w-6" slot="prepend" />
              {{ $t('frontend_groovemail_forms_step1_add_a_new_field_in_form') }}
            </gd-button>

            <!-- Form's columns and rows control buttons -->
            <div v-if="showRows && substep == 'design'" class="flex justify-center w-full">
              <gd-button
                @click='addRow'
                class="mx-3"
              >
                <PlusIcon class="h-6 w-6" slot="prepend" />
                {{ $t('frontend_row') }}
              </gd-button>
              <gd-button
                @click='addColumn'
                class="mx-3"
              >
                <PlusIcon class="h-6 w-6" slot="prepend" />
                {{ $t('frontend_column') }}
              </gd-button>
            </div>
          </div>
          <div :class="activePreset.styles.form.backgroundPattern+'-pattern'" class="pattern-background"></div>
        </div>
        
        <!-- form style builder -->
        <groovemail-form-style
          v-if='formStyleBuilder && substep == "design"'
          @changed='styleChanged'
          @close='closeStyleEditor()'
          :type="formStyleBuilderType"
          :styles="activePreset.styles"
          :fields="localModel.form_fields.fields"
          :buttonSublabel="localModel.form_fields.button_sublabel"
          :fontData='fontData'
        ></groovemail-form-style>
      </div>
      <div v-show="printing" id="formhtml">
        <html-raw-form class-prefix="" :active-preset="activePreset" :mailform="localModel" />
      </div>
    </div>

    <!-- Delete field Modal -->
    <confirm-modal
      :ref="`confirmation-delete-broadcast-cat`"
      :name="`confirmation-delete-broadcast-cat`"
      :buttonText="$t('frontend_delete')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_non_revertable')"
      @confirm="confirmDeleteFormField"
      @close="closeDeleteFormFieldModal"
    />
  </div>
</template>
<script>
import Axios from 'axios';
import Notify from '@groovepages/gd-ui-kit/notify';
import { mapState } from 'vuex';
import draggable from 'vuedraggable';
import Treeselect from '@riophae/vue-treeselect';
import { required, minLength, maxLength,} from 'vuelidate/lib/validators';
import tailwindConfig, { fonts } from '@groovepages/gp-page-ui-kit/tailwind';
import Customfield from '@/models/Customfield';

import CreateUpdateField from '../pages/customfields/create-update-field';
import GroovemailFormStyle from './GrooveMailFormStyle';
import HtmlRawForm from './HtmlRawForm';

// import field types components
import FormButton from './form-elements/Button';
import FormTextBox from './form-elements/TextBox';
import FormParagraph from './form-elements/Paragraph';
import FormTextArea from './form-elements/TextArea';
import FormDropdown from './form-elements/Dropdown';
import FormRadio from './form-elements/Radio';
import FormCheckbox from './form-elements/Checkbox';
import FormAccept from './form-elements/Accept';
import FormDateBox from './form-elements/DateBox';

import { showRequestErrorAlert } from '@/components/showDialog.js';

// import icons
import DragIcon from '@/assets/images/icons/new/drag_new.svg';
import DeleteIcon from '@/assets/images/icons/new/trash_new.svg';
import PreviewIcon from '@/assets/images/icons/new/preview_new.svg';
import PreviewCrossedIcon from '@/assets/images/icons/new/preview_crossed_new.svg';
import PlusIcon from '@/assets/images/icons/new/plus-small_new.svg';
import EditIcon from '@/assets/images/icons/new/edit_new.svg';


function repositionNewFieldModal() {
  const wrapper = document.querySelector('#add-new-field-wrapper');
  if (!wrapper) return;

  const heightDiff = window.innerHeight
    - document.querySelector('#canvasContainer').clientHeight
    - 120;
  const distance = window.innerHeight
    - document.querySelector('#canvasContainer').offsetHeight
    - document.querySelector('#canvasContainer').offsetTop
    - 152 - 60;

  if(heightDiff > 0 && distance > 0){
    document.querySelector('#add-new-field-wrapper').style.paddingBottom = (distance) + 'px';
  }else{
    document.querySelector('#add-new-field-wrapper').style.paddingBottom = '';
  }
}
window.onresize = function () {
  repositionNewFieldModal();
};


export default {
  name: 'GroovemailForm',

  props: {
    model: {
      required: true,
    },
    substep: {
      required: true,
    },
  },

  data(){
    return {
      showRows: false,
      rows: [],
      currentTab: 'step-1',
      showEditCustomFieldPopup: false,
      showEditStandardFieldPopup: false,
      fontData: tailwindConfig.fontsData,
      localModel: this.model,
      variations: [],
      showInputOnAddField: false,
      showActionItems: false,
      currentFieldHovered: -1,
      currentFieldEditted: -1,
      showCustomPopupOnAddField: false,
      standardEditModel: {
        fieldtype: '',
        id: '',
        identifier: '',
        mandatory: 0,
        name: '',
        placeholder: ',',
        type: '',
      },
      customfieldData: {},
      customFieldEditId: -1,
      currentSelectedField: null,
      clearOnSelect: true,
      clearable: false,
      closeOnSelect: true,
      standardFieldType: 'textbox',
      customfields: [],
      existingfield_options: [
        {
          name: 'Standard Field',
          fields: [
            {
              type: 'textbox',
              placeholder: 'Email',
              id: 'standard1',
              identifier: 'Email',
              mandatory: 1,
              name: 'email',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Firstname',
              id: 'standard2',
              identifier: 'Firstname',
              mandatory: 0,
              name: 'first_name',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Lastname',
              id: 'standard3',
              identifier: 'Lastname',
              mandatory: 0,
              name: 'last_name',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Full Name',
              id: 'standard16',
              identifier: 'Full Name',
              mandatory: 0,
              name: 'full_name',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Address',
              id: 'standard4',
              identifier: 'Address',
              mandatory: 0,
              name: 'address_1',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Secondary Address',
              id: 'standard15',
              identifier: 'Secondary Address',
              mandatory: 0,
              name: 'address_2',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Company',
              id: 'standard5',
              identifier: 'Company',
              mandatory: 0,
              name: 'company',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Phone',
              id: 'standard6',
              identifier: 'Phone',
              mandatory: 1,
              name: 'phone_number',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'City',
              id: 'standard11',
              identifier: 'City',
              mandatory: 0,
              name: 'city',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'State',
              id: 'standard7',
              identifier: 'State',
              mandatory: 0,
              name: 'state',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Country',
              id: 'standard8',
              identifier: 'Country',
              mandatory: 0,
              name: 'country',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Postalcode',
              id: 'standard9',
              identifier: 'Postalcode',
              mandatory: 0,
              name: 'zip',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'URL',
              id: 'standard10',
              identifier: 'URL',
              mandatory: 0,
              name: 'url',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Tax Number',
              id: 'standard12',
              identifier: 'Tax Number',
              mandatory: 0,
              name: 'tax_number',
              fieldtype: 'standard',
            },
            {
              type: 'textbox',
              placeholder: 'Billing Address',
              id: 'standard13',
              identifier: 'Billing Address',
              mandatory: 0,
              name: 'billing_address',
              fieldtype: 'standard',
            },
            {
              type: 'accept',
              placeholder: 'I accept the terms and conditions',
              id: 'standard14',
              identifier: 'Accept terms and conditions',
              mandatory: 0,
              name: 'accept',
              fieldtype: 'standard',
            },
            {
              type: 'datepicker',
              placeholder: 'Date of Birth',
              id: 'standard17',
              identifier: 'Date of Birth',
              mandatory: 0,
              name: 'date_of_birth',
              fieldtype: 'standard',
            },
          ],
        },
        {
          name: 'Custom Field',
          fields: [],
        },
        {
          name: 'Others',
          fields: [
            {
              type: 'heading',
              placeholder: 'Interested In Our Newsletter?',
              id: 'heading',
              identifier: 'Heading',
              mandatory: 0,
              name: 'heading',
              fieldtype: 'heading',
            },
            {
              type: 'subheading',
              placeholder: 'Stay in the know with news and promotions.',
              id: 'subheading',
              identifier: 'Subheading',
              mandatory: 0,
              name: 'subheading',
              fieldtype: 'subheading',
            },
            {
              type: 'paragraph',
              placeholder: 'Click to change me!',
              id: 'paragraph',
              identifier: 'Paragraph',
              mandatory: 0,
              name: 'paragraph',
              fieldtype: 'paragraph',
            },
          ],
        },
      ],
      formStyleBuilderType: '',
      formMiniIndex: null,
    };
  },


  computed: {
    ...mapState({
      activePresetId: state => state.forms.activePresetId,
      printing: state => state.forms.printing,
      layoutType: state => state.forms.layoutType,
      hideLabels: state => state.forms.hideLabels,
      alignment: state => state.forms.alignment,
      previewWidth: state => state.forms.previewWidth,
    }),
    formStyleBuilder() {
      return this.$store.getters['forms/formStyleBuilder'];
    },
    screenWidth() {
      return `${this.previewWidth}px`;
    },
    form_fields() {
      return this.localModel.form_fields;
    },
    buttonClass() {
      if(this.activePreset.styles.button.animation){
        return `animate__infinite animate__slower animate__${this.activePreset.styles.button.animation} animate__animated`;
      }
      return '';
    },
    activePreset: {
      get() { return this.$store.getters['forms/activePreset']; },
      set(value) { this.$store.dispatch('forms/updatePreset', value); }
    },
    isStyleChanged() {
      return this.$store.getters['forms/isStyleChanged'];
    },
    tabs() {
      return this.variations.map(item => {
        const newItem = [];
        newItem['title'] = item.name;
        newItem['value'] = item.id;
        return newItem;
      });
    },
    customFieldOptions() {
      return [
        {
          id: 'dropdown',
          label: this.$t('frontend_groovemail_forms_form_creation_dropdown_option'),
        },
        {
          id: 'radio',
          label: this.$t('frontend_groovemail_forms_form_creation_radio_option'),
        },
        {
          id: 'checkbox',
          label: this.$t('frontend_groovemail_forms_form_creation_checkbox_option'),
        },
        {
          id: 'textbox',
          label: this.$t('frontend_groovemail_forms_form_creation_input_option'),
        },
        {
          id: 'datepicker',
          label: 'Datepicker',
        },
        {
          id: 'textarea',
          label: this.$t('frontend_groovemail_forms_form_creation_textarea_option'),
        },
      ];
    },

    formFieldsData() {
      const formFieldsData = [
        {
          id: 'standard',
          label: this.$t('frontend_groovemail_forms_step1_standard_fields_title'),
          children: [],
        },
        {
          id: 'custom',
          label: this.$t('frontend_groovemail_forms_step1_custom_fields_title'),
          children: [],
        },
        {
          id: 'other',
          label: this.$t('Others'),
          children: [],
        },
        {
          id: 'create_field',
          label: this.$t('frontend_groovemail_customfields_index_new_custom'),
          children: [
            {
              id: 'createNewCustomField1',
              label: this.$t('frontend_groovemail_customfields_index_new_custom'),
              isDisabled: false,
            },
          ],
        },
      ];

      if (
        this.existingfield_options &&
        this.existingfield_options.length &&
        this.existingfield_options[0].fields &&
        this.existingfield_options[0].fields.length
      ) {
        this.existingfield_options[0].fields.forEach((element) => {
          formFieldsData[0].children.push({
            id: element.id,
            label: element.identifier,
            isDisabled: this.checkFieldInForm(element),
          });
        });
      }
      if (
        this.existingfield_options &&
        this.existingfield_options.length &&
        this.existingfield_options[1].fields &&
        this.existingfield_options[1].fields.length
      ) {
        this.existingfield_options[1].fields.forEach((element) => {
          formFieldsData[1].children.push({
            id: element.id,
            label: element.identifier,
            isDisabled: this.checkFieldInForm(element),
          });
        });
      }
      this.existingfield_options[2].fields.forEach((element) => {
        formFieldsData[2].children.push({
          id: element.id,
          label: element.identifier,
          isDisabled: this.checkFieldInForm(element),
        });
      });
      return formFieldsData;
    },
  },

  mounted() {
    if(!this.localModel.form_fields.advanced_layout_v2){
      if(!this.localModel.form_fields.advanced_layout){
        this.localModel.form_fields = {
          advanced_layout_v2: true,
          layout_type: 'vertical',
          fields: [...this.localModel.form_fields, {fieldtype:"submit", type:"submit", id:"submit"}],
        };
        this.resetLayout();
      } else{
        this.localModel.form_fields = {
          advanced_layout_v2: true,
          layout_type: 'custom',
          fields: [
            ...this.localModel.form_fields.rows.map((i) => i.map((e) => e.fields)).flat(2),
          ],
          rows: this.localModel.form_fields.rows.map(a => a.map(e => {e.fields = e.fields.map(o => o.id);return e})),
        };
      }
    } else if(!this.localModel.form_fields.layout_type){
        this.localModel.form_fields.layout_type = 'custom';
    }

    if (!this.localModel.form_fields.headings_v2) {
        const subheading = this.localModel.form_sub_heading;
        if (subheading) {
          this.localModel.form_fields.fields.unshift({
            type: 'subheading',
            placeholder: subheading,
            id: `subheading${Date.now()}`,
            identifier: `Subheading${Date.now()}`,
            mandatory: 0,
            name: 'subheading',
            fieldtype: 'subheading',
          });
          this.localModel.form_sub_heading = '';
        }

        const heading = this.localModel.form_heading;
        if (heading) {
          this.localModel.form_fields.fields.unshift({
              type: 'heading',
              placeholder: heading,
              id: `heading${Date.now()}`,
              identifier: `Heading${Date.now()}`,
              mandatory: 0,
              name: 'heading',
              fieldtype: 'heading',
          });
          this.localModel.form_heading = '';
        }

        this.$set(this.localModel.form_fields, 'headings_v2', true);
    }
    if(typeof this.localModel.form_fields.hide_labels === 'undefined'){
      this.localModel.form_fields.hide_labels = true;
    }
    this.$store.commit('forms/SET_LAYOUT_TYPE', this.localModel.form_fields.layout_type);
    this.$store.commit('forms/SET_HIDE_LABELS', this.localModel.form_fields.hide_labels);
  },

  async created() {
    this.$root.$on('updateCustomFields', () => this.fetchandAssignCustomFields());
    await this.fetchandAssignCustomFields();
    
    // Fonts
    const text = await Axios({
      method: 'GET',
      url: 'https://www.googleapis.com/webfonts/v1/webfonts?key=AIzaSyDm7uQo4WoXxRys29dzwb0V-QVqN213TUM'
    })
      .then((response) => {
        const fontData = {};
        const fontFamily = {};
        response.data.items.map((font) => {
          if (Object.keys(fonts) && Object.keys(fonts).includes(font.family.toLowerCase().replace(/\s/g, '-'))) {
            fontFamily[font.family] = font.family;
            fontData[font.family] = {
              name: font.family,
              weight: font.variants
            };
          }
        });
        return {
          fontData,
          fontFamily
        };
      })
      .catch((error) => {
        showRequestErrorAlert(error.response?.data?.error);
      });

      this.fontData = text.fontData;
  },

  watch: {
    alignment: {
      handler(newVal) {
        this.activePreset.styles.heading.text.textAlign = newVal;
        this.activePreset.styles.paragraphs.text.textAlign = newVal;
        this.activePreset.styles.subheading.text.textAlign = newVal;
        this.activePreset.styles.button.alignment = newVal === 'center' ? 'full' : newVal;
        this.activePreset.styles.button.text.textAlign = newVal;
        this.activePreset.styles.button_sublabel.text.textAlign = newVal;
        this.saveStyles();
      }
    },
    activePresetId: {
      handler(newVal) {
        if (!this.localModel.default_preset || this.localModel.default_preset !== newVal) {
          this.localModel.default_preset = newVal;
          // this.$set(this.localModel, 'default_preset', newVal);
        }
      }
    },
    layoutType: {
      handler(newVal) {
        this.localModel.form_fields.layout_type = newVal;
      }
    },
    hideLabels: {
      handler(newVal) {
        this.localModel.form_fields.hide_labels = newVal;
      }
    },
    form_fields: {
      deep: true,
      immediate: true,
      handler() {
          this.updateRows();
          // console.log(this.substep, this.rows, this.activePreset);
          // if(this.substep == 'design'){
          //  let fieldStyles = {};
          //  this.localModel.form_fields.fields.forEach(i => {
          //    console.log(i);
          //    fieldStyles[i.id] = {};
          //  });
          //  console.log(fieldStyles);
          //  this.localModel.styles.fields = fieldStyles;
          // }
      }
    },
    rows: {
      deep: true,
      handler(newVal) {
        if(this.substep === 'build' || (this.substep === 'design' && this.localModel.form_fields.layout_type !== 'custom')){
          const fields = JSON.stringify(newVal[0][0].fields);
          if(JSON.stringify(this.localModel.form_fields.fields) !== fields){
            this.localModel.form_fields.fields = JSON.parse(fields);
          }
        }
        if(this.substep === 'design' && this.localModel.form_fields.layout_type === 'custom'){
          let rows = JSON.parse(JSON.stringify(newVal));
          rows = JSON.stringify(rows.map(a => a.map(e => {e.fields = e.fields.map(o => o.id); return e;})));
          if(JSON.stringify(this.localModel.form_fields.rows) !== rows){
            this.localModel.form_fields.rows = JSON.parse(rows);
          }
        }
      }
    },
    substep: {
      immediate: true,
      handler() {
        this.updateRows();
        this.initializeFields();
      }
    },
    localModel: {
      deep: true,
      handler(){
        this.$emit('updateModel', this.localModel);
      }
    },
  },
  methods: {
    isStandardFieldMandatory(fieldData) {
      if (fieldData.name === 'phone_number' && fieldData.mandatory) {
        Notify.warn(
          this.$t('frontend_groovemail_forms_phone_number_field_mandatory_warning_message')
        );
      }
      this.standardEditModel.mandatory = !this.standardEditModel.mandatory;
    },
    getStyle(id, type){
      if (type === 'paragraph') {
        type = 'paragraphs';
      }
      let advancedStyles = {};
      if(
        this.activePreset.styles.advanced &&
        this.activePreset.styles.advanced.fields &&
        this.activePreset.styles.advanced.fields[id]
      ){
        advancedStyles = this.activePreset.styles.advanced.fields[id];
      }

      return {...this.activePreset.styles[type], ...advancedStyles};
    },
    deleteCol(indexRow, indexCol){
      this.rows[indexRow].splice(indexCol, 1);
    },
    deleteRow(indexRow){
      this.rows.splice(indexRow, 1);
    },
    updateRows() {
      if (!this.localModel.form_fields?.fields) {
        return;
      }
      if(this.substep === 'build' || (this.substep === 'design' && this.localModel.form_fields.layout_type !== 'custom')){
          this.rows = [
            [
              { width: 100, fields: JSON.parse(JSON.stringify(this.localModel.form_fields.fields)) }
            ]
          ];
        }
        if(this.substep === 'design' && this.localModel.form_fields.layout_type === 'custom'){
          const formFields = JSON.parse(JSON.stringify(this.localModel.form_fields));
          const fieldsOnRows = [...formFields.rows.map((i) => i.map((e) => e.fields)).flat(2)];
          if(fieldsOnRows.length !== formFields.fields.length){
            formFields.fields.forEach(i => {
              if(!fieldsOnRows.find(f => f === i.id)){
                const lastIsButton = formFields.rows[formFields.rows.length - 1][0].fields.at(-1) === 'submit';
                let last = null;
                if (lastIsButton) {
                  last = formFields.rows[formFields.rows.length - 1][0].fields.pop();
                }
                formFields.rows[formFields.rows.length - 1][0].fields.push(i.id);
                if (last) {
                  formFields.rows[formFields.rows.length - 1][0].fields.push(last);
                }
              }
            });
          }
          const rows = formFields.rows.map(
            a => a.map(
              e => {
                e.fields = e.fields.map(
                  o => {
                    return formFields.fields.find(
                      f => f.id === o
                    );
                  });
                e.fields = e.fields.filter(
                  o => o !== undefined
                );
                return e;
              }
            )
          );
          this.rows = rows;
        }
    },
    getColumnFields(fieldIds) {
      return this.localModel.form_fields.fields.filter(i => fieldIds.includes(i.id));
    },
    resetLayout() {
      const fields = this.localModel.form_fields.fields.map((item) => item.id);
      this.localModel.form_fields.rows = [
        [
          { width:100, fields }
        ],
      ];
      this.localModel.form_fields = JSON.parse(JSON.stringify(this.localModel.form_fields));
    },
    mouseoo() {
      // console.log(str);
    },
    toggleColumns() {
      this.showRows = !this.showRows;
    },
    addColumn() {
      this.localModel.form_fields.rows[this.localModel.form_fields.rows.length - 1].push({width: 100, fields: []});
    },
    addRow() {
      this.localModel.form_fields.rows.push([{width: 100, fields: []}]);
    },

    /* save the styles */
    async saveStyles(){
      // check if the styles have changed
      if(this.isStyleChanged) {
        // check if the style is a global style or a local style
        if(this.activePreset.form_id){
          // save the form style locally
          this.$store.dispatch('forms/createLocalPreset', {...this.activePreset, formId: this.localModel.formid});
        } else {
          // opne save style modal
          this.$root.$emit('modal-open', 'confirm-save-style-type');
        }
      }
    },

    /* close the style editor */
    closeStyleEditor() {
      // if the styles have changed
      if(this.isStyleChanged) {
        // show alret modal to save the form style or not before leaving the page
        this.$root.$emit('modal-open', 'confirm-save-style-type');

        // stop the function
        return;
      }

      // close the form style builder
      this.$store.dispatch('forms/setFormStyleBuilder', false);
    },
    
    /* style changed */
    styleChanged(styles){
      // set style changed to true
      this.$store.dispatch('forms/setIsStyleChanged', true);

      // set the new styles
      this.activePreset.styles = styles;
    },

    editStyle(type){
      // open the form style builder
      this.$store.dispatch('forms/setFormStyleBuilder', true);

      this.formStyleBuilderType = type;
    },

    // Titles
    openAddFieldToFormModal() {
      this.showInputOnAddField = true;
      this.showEditCustomFieldPopup = false;
      this.showEditStandardFieldPopup = false;

      this.$nextTick(() => {
        repositionNewFieldModal();
      });
    },
    showFieldsActionItems(mainindex) {
      if(this.substep === 'design'){
        if(typeof mainindex === 'number'){
          this.editStyle('field');
        }else{
          this.editStyle(mainindex);
        }
      }
      if(this.substep === 'build'){
        this.showActionItems = true;
        this.currentFieldHovered = mainindex;
      }
    },
    hideFieldsActionItems() {
      this.showActionItems = false;
      this.currentFieldHovered = -1;
    },


    toggleButtonSublabel() {
      if(this.localModel.form_fields.button_sublabel){
        this.localModel.form_fields.button_sublabel = null;
      }else{
        this.localModel.form_fields.button_sublabel = 'click to edit me';
      }
    },
    async editChoosenField(field, index) {
      this.showInputOnAddField = false;
      this.showCustomPopupOnAddField = false;
      this.showEditCustomFieldPopup = false;
      this.showEditStandardFieldPopup = false;
      this.showActionItems = false;
      this.currentFieldHovered = -1;
      this.currentFieldEditted = index;
      if (field.fieldtype === 'standard') {
        this.standardEditModel.fieldtype = field.fieldtype;
        this.standardEditModel.id = field.id;
        this.standardEditModel.identifier = field.identifier;
        this.standardEditModel.mandatory = field.mandatory;
        this.standardEditModel.name = field.name;
        this.standardEditModel.placeholder = field.placeholder;
        this.standardEditModel.type = field.type;
        this.showEditStandardFieldPopup = true;
      } else if (field.fieldtype === 'custom') {
        this.showLoader();
        this.customfieldData = await Customfield.$find(field.id);
        this.customFieldEditId = field.id;
        this.showEditCustomFieldPopup = true;
        this.hideLoader();
      }
    },


    // open delete FormField modal
    async openDeleteFormFieldModal(index) {
      // set the FormField id
      this.formMiniIndex = index;

      // open the modal
      this.$refs[`confirmation-delete-broadcast-cat`].open();
    },

    // confirm remove form field
    confirmDeleteFormField() {
      if (this.formMiniIndex > -1) {
        this.localModel.form_fields.fields.splice(this.formMiniIndex, 1);
      }
    },

    // close delete FormField modal
    closeDeleteFormFieldModal() {
      this.formMiniIndex = null;
    },

    // remove field from form
    async removeFieldFromForm(element, mainindex) {
      this.showActionItems = false;
      this.currentFieldHovered = -1;
      if (
        element.name === 'phone_number' &&
        (this.localModel.welcome_msg_option === 'sms' ||
          (this.localModel.optin === 'double' &&
            this.localModel.confirmlink_sendoption === 'sms'))
      ) {
        await showRequestErrorAlert(this.$t('frontend_groovemail_form_phone_number_cant_be_deleted_if_sms_configured'));
      } else {
        // open the delete FormField modal
        this.openDeleteFormFieldModal(mainindex);
      }
    },
    formFieldSelectedSelected(node) {
      if (node === 'createNewCustomField1') {
        this.openAddCustomFieldPopup();
      }
    },
    updateStandardField(mainindex) {
      this.$v.standardEditModel.placeholder.$touch();
      if (!this.$v.standardEditModel.placeholder.$invalid) {
        this.showEditStandardFieldPopup = false;
        this.localModel.form_fields.fields[mainindex] = {
          ...this.localModel.form_fields.fields[mainindex],
          placeholder: this.standardEditModel.placeholder,
          mandatory: this.standardEditModel.mandatory,
        };
        this.initializeStandardFields();
        this.updateRows();
      }
    },
    initializeStandardFields() {
      this.standardEditModel = {
        fieldtype: '',
        id: '',
        identifier: '',
        mandatory: 0,
        name: '',
        placeholder: '',
        type: '',
      };
      this.$v.standardEditModel.placeholder.$reset();
    },
    async fetchandAssignCustomFields() {
      this.customfields = await Customfield.$get();
      const customfields = [];
      for (let i = 0; i < this.customfields.length; i += 1 ) {
        if (
          this.customfields[i].type === 'textarea' ||
          this.customfields[i].type === 'datepicker' ||
          this.customfields[i].type === 'textbox'
        ) {
          customfields.push({
            id: this.customfields[i].id,
            type: this.customfields[i].type,
            placeholder: this.customfields[i].fieldplaceholder,
            mandatory: this.customfields[i].mandatory,
            identifier: this.customfields[i].identifier,
            default: this.customfields[i].default ? this.customfields[i].default : '',
            fieldtype: 'custom',
          });
        } else {
          const options =
            this.customfields[i].fieldoptions !== '' ||
            this.customfields[i].fieldoptions != null
              ? JSON.parse(this.customfields[i].fieldoptions)
              : [];
          customfields.push({
            id: this.customfields[i].id,
            type: this.customfields[i].type,
            fieldlabel: this.customfields[i].fieldlabel,
            options,
            identifier: this.customfields[i].identifier,
            mandatory: this.customfields[i].mandatory,
            default: this.customfields[i].default ? this.customfields[i].default : '',
            fieldtype: 'custom',
          });
        }
      }
      this.existingfield_options[1].fields = customfields;
    },
    closeAddFieldPopup() {
      this.showInputOnAddField = false;
      this.initializeFields();
    },
    checkFieldInForm(element) {
      let disableField = false;
      if (this.localModel.form_fields && this.localModel.form_fields.fields && this.localModel.form_fields.fields.length) {
        this.localModel.form_fields.fields.forEach((fieldEle) => {
          if (element.identifier === "Full Name" && (fieldEle.identifier === "Firstname" || fieldEle.identifier === "First Name" || fieldEle.identifier === "Lastname")) {
            disableField = true;
          }
          if ((element.identifier === "Firstname" || element.identifier === "First Name" || element.identifier === "Lastname") && fieldEle.identifier === "Full Name") {
            disableField = true;
          }
          if (element.id === fieldEle.id) {
            disableField = true;
          }
        });
      }
      return disableField;
    },
    async addFieldToForm() {
      if (!this.currentSelectedField) {
        await showRequestErrorAlert(this.$t('frontend_groovemail_forms_step1_select_a_field_to_proceed'));
      } else {
        let currentField = null;
        currentField = this.findFormField(this.existingfield_options[0].fields);
        if (!currentField) {
          currentField = this.findFormField(this.existingfield_options[2].fields);
          if(currentField){
            currentField = JSON.parse(JSON.stringify(currentField));
            currentField.id = currentField.id + Date.now();
            currentField.identifier = currentField.identifier + Date.now();
          }
        }
        if (!currentField) {
          currentField = this.findFormField(
            this.existingfield_options[1].fields
          );
          currentField = { ...currentField, label: currentField.fieldlabel };
          delete currentField.fieldlabel;
        }
        this.showInputOnAddField = false;
        const lastIsButton = this.localModel.form_fields.fields.at(-1).id === 'submit';
        let last = null;
        if (lastIsButton) {
          last = this.localModel.form_fields.fields.pop();
        }
        this.localModel.form_fields.fields.push(currentField);
        if (last) {
          this.localModel.form_fields.fields.push(last);
        }
        this.initializeFields();
      }
    },
    findFormField(fieldsArray) {
      let field = null;
      if (fieldsArray && fieldsArray.length) {
        field = fieldsArray.find(
          (element) => element.id === this.currentSelectedField
        );
      }
      return field;
    },
    initializeFields() {
      this.currentSelectedField = null;
      if(this.substep === 'build'){
        this.showRows = false;
      }
      if(this.substep === 'design'){
        this.showRows = false;
          // ...this.localModel.form_fields.rows.map((i) => i.map((e) => e.fields)).flat(2),
        }
    },
    openAddCustomFieldPopup() {
      this.showCustomPopupOnAddField = true;
      const wrapper = document.querySelector('#add-new-field-wrapper');
      wrapper.style.paddingBottom = '';
    },

    closeAddCustomFieldPopup(customFieldData) {
      this.showCustomPopupOnAddField = false;
      this.showInputOnAddField = false;
      if (customFieldData) {
        const lastIsButton = this.localModel.form_fields.fields.at(-1).id === 'submit';
        let last = null;
        if (lastIsButton) {
          last = this.localModel.form_fields.fields.pop();
        }

        if (customFieldData.type === 'textbox' || customFieldData.type === 'datepicker' || customFieldData.type === 'textarea') {
          this.localModel.form_fields.fields.push({
            id: customFieldData.id,
            type: customFieldData.type,
            placeholder: customFieldData.fieldplaceholder,
            mandatory: customFieldData.mandatory,
            default: customFieldData.default ? customFieldData.default : '',
            identifier: customFieldData.identifier,
            fieldtype: 'custom',
          });
        } else {
          this.localModel.form_fields.fields.push({
            id: customFieldData.id,
            type: customFieldData.type,
            label: customFieldData.fieldlabel,
            options: JSON.parse(customFieldData.fieldoptions),
            identifier: customFieldData.identifier,
            mandatory: customFieldData.mandatory,
            default: customFieldData.default ? customFieldData.default : '',
            fieldtype: 'custom',
          });
        }
        if (last) {
          this.localModel.form_fields.fields.push(last);
        }
      }
      this.currentSelectedField = null;
      this.currentFieldEditted = -1;
      this.initializeFields();
    },
    showLoader() {
      this.$emit('showLoader');
    },

    hideLoader() {
      this.$emit('hideLoader');
    },
    closeCustomFieldEditPopup(customFieldData) {
      this.showEditCustomFieldPopup = false;
      if (customFieldData) {
        if (customFieldData.type === 'textbox' || customFieldData.type === 'datepicker' || customFieldData.type === 'textarea') {
          this.localModel.form_fields.fields[this.currentFieldEditted] = {
            ...this.localModel.form_fields.fields[this.currentFieldEditted],
            placeholder: customFieldData.fieldplaceholder,
            mandatory: customFieldData.mandatory,
            default: customFieldData.default ? customFieldData.default : '',
          };
        } else {
          this.localModel.form_fields.fields[this.currentFieldEditted] = {
            ...this.localModel.form_fields.fields[this.currentFieldEditted],
            label: customFieldData.fieldlabel,
            options: JSON.parse(customFieldData.fieldoptions),
            mandatory: customFieldData.mandatory,
            default: customFieldData.default ? customFieldData.default : '',
          };
        }
        this.$parent.$parent.$parent.$emit('saveFormWithUpdatedFields');
      }
      this.currentFieldEditted = -1;
      this.initializeFields();
      this.updateRows();
    },
    closeStandardFieldEditPopup() {
      this.showEditStandardFieldPopup = false;
      this.initializeStandardFields();
    },
  },
  validations: {
    standardEditModel: {
      placeholder: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(50),
      },
    },
  },
  components: {
    GroovemailFormStyle,
    DragIcon,
    draggable,
    Treeselect,
    CreateUpdateField,
    FormButton,
    FormTextBox,
    FormParagraph,
    FormTextArea,
    FormDropdown,
    FormRadio,
    FormCheckbox,
    FormAccept,
    FormDateBox,
    HtmlRawForm,
    PreviewIcon,
    PreviewCrossedIcon,
    DeleteIcon,
    PlusIcon,
    EditIcon,
  }
};
</script>

<style>
.min-h-10{
  min-height:100px;
}

.form-row, .formColumn {
  position: relative;
  border: dashed 1px #ccc;
  margin: 5px;
}
.form-row {
  border-style:solid;
  margin: 15px 5px;
  position: relative;
}
.formColumn:before {
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    left: 0px;
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 0px 0px 5px 0px;
    top: 0px;
}
.form-row:before {
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    left: calc(50% - 10px);
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 5px 5px 0px 0px;
    top: -20px;
}
.form-builder-wrapper:before{
    border: 1px solid #767070ad;
    background: #fff;
    content: " ";
    height: 20px;
    background-color: #fff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'%3E%3C!--! Font Awesome Pro 6.1.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2022 Fonticons, Inc. --%3E%3Cpath d='M512 255.1c0 8.188-3.125 16.41-9.375 22.66l-72 72C424.4 356.9 416.2 360 408 360c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62L402.8 288H288v114.8l17.38-17.38C311.6 379.1 319.8 376 328 376c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62l-72 72C272.4 508.9 264.2 512 256 512s-16.38-3.125-22.62-9.375l-72-72C155.1 424.4 152 416.2 152 408c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375L224 402.8V288H109.3l17.38 17.38C132.9 311.6 136 319.8 136 328c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375l-72-72C3.125 272.4 0 264.2 0 255.1s3.125-16.34 9.375-22.59l72-72C87.63 155.1 95.81 152 104 152c18.28 0 32 14.95 32 32c0 8.188-3.125 16.38-9.375 22.62L109.3 224H224V109.3L206.6 126.6C200.4 132.9 192.2 136 184 136c-18.28 0-32-14.95-32-32c0-8.188 3.125-16.38 9.375-22.62l72-72C239.6 3.125 247.8 0 256 0s16.38 3.125 22.62 9.375l72 72C356.9 87.63 360 95.81 360 104c0 17.05-13.73 32-32 32c-8.188 0-16.38-3.125-22.62-9.375L288 109.3V224h114.8l-17.38-17.38C379.1 200.4 376 192.2 376 184c0-17.05 13.73-32 32-32c8.188 0 16.38 3.125 22.62 9.375l72 72C508.9 239.6 512 247.8 512 255.1z'/%3E%3C/svg%3E");
    display:none;
    width:20px;
    position: absolute;
    cursor: move;
    padding: 2px;
    background-position: center;
    background-size: 11px;
    background-repeat: no-repeat;
    border-radius: 5px;
    top: calc(50% - 10px);
    left: -16px;
    z-index: 10;

}
.form-builder-wrapper{
  position:relative
}
.form-row:hover:before, .formColumn:hover:before, .form-builder-wrapper:hover:before {
  display:block;
}

.formPlaceholder {
  background: #00000020;
  padding: 10px;
  padding-top: 20px;
  padding-bottom: 0px;
}
.delete_col {
  display: none;
      background: #fff;
    position: absolute;
    border-radius: 0 0 0 5px;
    right: -1px;
    top: -1px;
    cursor: pointer;
}
.formColumn:hover .delete_col, .form-row:hover .delete_row {
  display: block;
}
.delete_row{
    display: none;
    background: #fff;
    position: absolute;
    border-radius: 0 0 0 5px;
    cursor: pointer;
    top: -20px;
    cursor: pointer;
    left: calc(50% - -11px);
  }

.groovemail-form-preset .container input:checked ~ .checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .container .checkmark:after {
  border-color: var(--form-style-color)!important;
}
.groovemail-form-preset .radio-container input:checked ~ .radio-checkmark {
  background-color: var(--form-style-background)!important;
  border: solid 1px var(--form-style-color)!important;
}
.groovemail-form-preset .radio-container .radio-checkmark:after {
  background: var(--form-style-color)!important;
}
.groovemail-form-preset input::placeholder, .groovemail-form-preset textarea::placeholder {
  color: var(--form-style-placeholder-color)!important;
}
.groovemail-form-preset {
  box-shadow: none;
  -webkit-box-shadow: none;
}
#canvasContainer {
  width: 100%;
  min-width: 400px;
  max-width: 1600px;
  max-height: calc(100vh - 120px);
  position: relative;
}
.groovemail-form-content {
  background-size: cover;
  padding-left: 0px;
  padding-right: 0px;
  padding-top: 25px;
  padding-bottom: 25px;
  z-index: auto !important;
  background-position-y: 50%;
  background-position-x: 50%;
}
.groovemail-form-content > * {
  z-index: 15;
}
.pattern-background {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 12;
}

.form-hover-field-tooltip {
  padding-bottom: 5px; top: -45px;
}
.form-hover-field-tooltip-start {
  padding-bottom: 5px; top: 25px; z-index: 2;
}

/* Patterns */
.Wavy-pattern {
    background-color: var(--gp-bg-back-color) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-radial-gradient(circle at 0 0, transparent 0, var(--gp-bg-back-color) var(--gp-bg-spacing)), repeating-linear-gradient(var(--gp-bg-front-alpha-color), var(--gp-bg-front-color)) !important;
}

.Rhombus-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: linear-gradient(135deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(315deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%) !important;
    background-position: var(--gp-bg-spacing) 0, var(--gp-bg-spacing) 0, 0 0, 0 0 !important;
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
}

.ZigZag-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: linear-gradient(135deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%), linear-gradient(315deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%);
    background-position: var(--gp-bg-spacing) 0, var(--gp-bg-spacing) 0, 0 0, 0 0;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-repeat: repeat;
}

.ZigZag3d-pattern {
    background: linear-gradient(135deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25%) -var(--gp-bg-spacing) 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(225deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%) -var(--gp-bg-spacing) 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(315deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25%) 0px 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2), linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%) 0px 0/ calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;
    background-color: var(--gp-bg-back-color, white) !important;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;

}

.Moon-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: radial-gradient(ellipse farthest-corner at var(--gp-bg-spacing) var(--gp-bg-spacing), var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-back-color, white) 50%);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
}

.Circles-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: radial-gradient(circle at center center, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-back-color, white)), repeating-radial-gradient(circle at center center, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-spacing), transparent calc(var(--gp-bg-spacing) * 2), transparent var(--gp-bg-spacing));
    background-blend-mode: multiply;
}

.Diagonal-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) var(--gp-bg-spacing), var(--gp-bg-back-color, white) var(--gp-bg-spacing), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) * 5));
}

.Diagonalv2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-image: repeating-linear-gradient(-45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) var(--gp-bg-spacing), var(--gp-bg-back-color, white) var(--gp-bg-spacing), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) * 5));
}

.Diagonalv3-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 0, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) 0, var(--gp-bg-back-color, white) 50%);
}

.Paper-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: -calc(var(--gp-bg-spacing) / 5) -calc(var(--gp-bg-spacing) / 5), -calc(var(--gp-bg-spacing) / 5) -calc(var(--gp-bg-spacing) / 5), -calc(var(--gp-bg-spacing) / 10) -calc(var(--gp-bg-spacing) / 10), -calc(var(--gp-bg-spacing) / 10) -calc(var(--gp-bg-spacing) / 10);
    background-size: calc(var(--gp-bg-spacing) * 5) calc(var(--gp-bg-spacing) * 5), calc(var(--gp-bg-spacing) * 5) calc(var(--gp-bg-spacing) * 5), var(--gp-bg-spacing) var(--gp-bg-spacing), var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 5), transparent calc(var(--gp-bg-spacing) / 5)), linear-gradient(90deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 5), transparent calc(var(--gp-bg-spacing) / 5)), linear-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), transparent calc(var(--gp-bg-spacing) / 10)), linear-gradient(90deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10));
}

.Isometric-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, 0 0, calc(var(--gp-bg-spacing) * 4)  calc(var(--gp-bg-spacing) * 7), calc(var(--gp-bg-spacing) * 4)  calc(var(--gp-bg-spacing) * 7), 0 0, calc(var(--gp-bg-spacing) * 4) calc(var(--gp-bg-spacing) * 7);
    background-size: calc(var(--gp-bg-spacing) * 8) calc(var(--gp-bg-spacing) * 14);
    background-image: linear-gradient(30deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(150deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(30deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(150deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 12%, transparent 12.5%, transparent 87%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 87.5%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), linear-gradient(60deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25.5%, transparent 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333))), linear-gradient(60deg, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 25%, transparent 25.5%, transparent 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)) 75%, var(--gp-bg-front-alpha-color, rgba(228, 63, 112, 0.3333)));
}

.Polka-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 20));
}

.Polkav2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), transparent calc(var(--gp-bg-spacing) / 20)), radial-gradient(var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 20), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 20));
}

.Lines-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(0deg, var(--gp-bg-back-color, white) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%);
}

.Linesv2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) 100%;
    background-image: linear-gradient(to right, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 2), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 2), var(--gp-bg-back-color, white));
}

.Linesv3-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: repeating-linear-gradient(0deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white));
}

.Linesv4-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2);
    background-image: repeating-linear-gradient(to right, var(--gp-bg-front-color, rgba(228, 63, 112, 1)), var(--gp-bg-front-color, rgba(228, 63, 112, 1)) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white) calc(var(--gp-bg-spacing) / 10), var(--gp-bg-back-color, white));
}

.Triangle-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-back-color, white) 50%);
}

.Trianglev2-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-size: var(--gp-bg-spacing) var(--gp-bg-spacing);
    background-image: linear-gradient(-45deg, var(--gp-bg-back-color, white), var(--gp-bg-back-color, white) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 50%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)));
}

.Rectangle-pattern {
    background-color: var(--gp-bg-back-color, white) !important;
    opacity: var(--gp-bg-opacity);
    background-position: 0 0, var(--gp-bg-spacing) var(--gp-bg-spacing) !important;
    background-size: calc(var(--gp-bg-spacing) * 2) calc(var(--gp-bg-spacing) * 2) !important;
    background-image: repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, transparent 25%, transparent 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))), repeating-linear-gradient(45deg, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 25%, var(--gp-bg-back-color, white) 25%, var(--gp-bg-back-color, white) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1)) 75%, var(--gp-bg-front-color, rgba(228, 63, 112, 1))) !important;
}
</style>
